import { CioTenantConfig } from "types/api"

import { FormState } from "./types"

export function configToForm(config: CioTenantConfig): FormState {
  return {
    enabled: config.enabled ?? false,
    siteId: config.siteId ?? "",
    // Show the masked value from the API (e.g. "****6570") so the user sees the key exists.
    // buildPayload skips these fields when unchanged.
    apiKey: config.apiKey ?? "",
    appApiKey: config.appApiKey ?? "",
    region: config.region ?? "EU",
    amountFormat: config.amountFormat ?? "formatted",
    transactionalTemplates: {
      activationEmail: String(config.transactionalTemplates?.activationEmail ?? ""),
      passwordReset: String(config.transactionalTemplates?.passwordReset ?? ""),
      kycRejected: String(config.transactionalTemplates?.kycRejected ?? ""),
      withdrawalSuccessful: String(config.transactionalTemplates?.withdrawalSuccessful ?? ""),
      passwordChanged: String(config.transactionalTemplates?.passwordChanged ?? ""),
      kycApproved: String(config.transactionalTemplates?.kycApproved ?? ""),
      kycRequest: String(config.transactionalTemplates?.kycRequest ?? ""),
      selfExclusionConfirm: String(config.transactionalTemplates?.selfExclusionConfirm ?? ""),
      selfExclusionSetDuration: String(config.transactionalTemplates?.selfExclusionSetDuration ?? ""),
      selfExclusionEnded: String(config.transactionalTemplates?.selfExclusionEnded ?? ""),
      adminMessage: String(config.transactionalTemplates?.adminMessage ?? "")
    },
    eventNames: {
      depositSuccess: config.eventNames?.depositSuccess ?? "",
      withdraw: config.eventNames?.withdraw ?? "",
      depositFailed: config.eventNames?.depositFailed ?? "",
      withdrawalRequested: config.eventNames?.withdrawalRequested ?? "",
      birthdayToday: config.eventNames?.birthdayToday ?? "",
      activationEmail: config.eventNames?.activationEmail ?? "",
      passwordResetRequested: config.eventNames?.passwordResetRequested ?? "",
      passwordChanged: config.eventNames?.passwordChanged ?? "",
      kycApproved: config.eventNames?.kycApproved ?? "",
      kycRejected: config.eventNames?.kycRejected ?? "",
      withdrawalSuccessful: config.eventNames?.withdrawalSuccessful ?? ""
    }
  }
}

export function buildPayload(form: FormState, loadedConfig: CioTenantConfig | null): Partial<CioTenantConfig> {
  // Only send a key when the user typed a new value (different from what the API returned).
  // This prevents accidentally overwriting a real key with the masked "****6570" string.
  const apiKeyChanged = form.apiKey !== (loadedConfig?.apiKey ?? "")
  const appApiKeyChanged = form.appApiKey !== (loadedConfig?.appApiKey ?? "")

  return {
    enabled: form.enabled,
    siteId: form.siteId || undefined,
    ...(apiKeyChanged && form.apiKey !== "" && { apiKey: form.apiKey }),
    ...(appApiKeyChanged && form.appApiKey !== "" && { appApiKey: form.appApiKey }),
    region: form.region,
    amountFormat: form.amountFormat,
    transactionalTemplates: {
      activationEmail: form.transactionalTemplates.activationEmail || undefined,
      passwordReset: form.transactionalTemplates.passwordReset || undefined,
      kycRejected: form.transactionalTemplates.kycRejected || undefined,
      withdrawalSuccessful: form.transactionalTemplates.withdrawalSuccessful || undefined,
      passwordChanged: form.transactionalTemplates.passwordChanged || undefined,
      kycApproved: form.transactionalTemplates.kycApproved || undefined,
      kycRequest: form.transactionalTemplates.kycRequest || undefined,
      selfExclusionConfirm: form.transactionalTemplates.selfExclusionConfirm || undefined,
      selfExclusionSetDuration: form.transactionalTemplates.selfExclusionSetDuration || undefined,
      selfExclusionEnded: form.transactionalTemplates.selfExclusionEnded || undefined,
      adminMessage: form.transactionalTemplates.adminMessage || undefined
    },
    eventNames: {
      depositSuccess: form.eventNames.depositSuccess || undefined,
      withdraw: form.eventNames.withdraw || undefined,
      depositFailed: form.eventNames.depositFailed || undefined,
      withdrawalRequested: form.eventNames.withdrawalRequested || undefined,
      birthdayToday: form.eventNames.birthdayToday || undefined,
      activationEmail: form.eventNames.activationEmail || undefined,
      passwordResetRequested: form.eventNames.passwordResetRequested || undefined,
      passwordChanged: form.eventNames.passwordChanged || undefined,
      kycApproved: form.eventNames.kycApproved || undefined,
      kycRejected: form.eventNames.kycRejected || undefined,
      withdrawalSuccessful: form.eventNames.withdrawalSuccessful || undefined
    }
  }
}
